import { defineMessages } from 'react-intl';

export default defineMessages({
    downloadQuoteTemplate: {
        id: 'quoteandbind.farm.views.farm-item-details.Download Quote Template',
        defaultMessage: 'Download Quote Template'
    },
    uploadQuoteTemplate: {
        id: 'quoteandbind.farm.views.item-details.Upload Completed Quote Template',
        defaultMessage: 'Upload Completed Quote Template'
    },
    uploadExcelTemplate: {
        id: 'quoteandbind.farm.views.farm-item-details.Upload excel and export functionality goes here',
        defaultMessage: 'Upload excel and export functionality goes here'
    },
    uploadExcelMessage: {
        id: 'PolicyChange.farm.views.farm-package-details.Download and Upload Quote Template',
        defaultMessage: 'Download and Upload Quote Template'
    },
    uploadExcelMessage: {
        id: 'PolicyChange.farm.views.farm-package-details.Unable to Quote the Policy.Unable to quote the policy. Please review the document for more details.',
        defaultMessage: 'Unable to quote the policy. Please review the document for more details.'
    },
    successMessage: {
        id: 'PolicyChange.farm.views.farm-package-details.Success',
        defaultMessage: 'Success'
    },
    successMessageInfo: {
        id: 'PolicyChange.farm.views.farm-package-details.Quote Processed Successfully.',
        defaultMessage: 'Quote Processed Successfully.'
    },
});
